import { __assign, __rest } from "tslib";
import React from 'react';
import InternalContainer from './internal';
import { useTelemetry } from '../internal/hooks/use-telemetry';
import { getExternalProps } from '../internal/utils/external-props';
var Container = function (_a) {
    var props = __rest(_a, []);
    useTelemetry('Container');
    var externalProps = getExternalProps(props);
    return React.createElement(InternalContainer, __assign({}, externalProps));
};
export default Container;
//# sourceMappingURL=index.js.map